import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DataTerm from '../../../atoms/list/DataTerm';
import DataDefinition from '../../../atoms/list/DataDefinition';
import DefinitionList from '../../DefinitionList';
import { useTranslation } from 'react-i18next';
import { readableDate } from '../../../../helpers/Date';
const InvonedDossierDetails = ({ dossier }) => {
    const { t } = useTranslation();
    const items = [
        {
            label: 'Status vordering',
            value: dossier.closed_at ? 'Afgewikkeld' : 'Lopend',
        },
        { label: 'Datum opdracht', value: readableDate(dossier.opened_at) },
        {
            label: 'Datum naheffingsaanslag',
            value: readableDate(dossier.assessment_date),
        },
        { label: 'Referentie', value: dossier.reference },
        {
            label: t('debtor'),
            value: dossier.debtor_name,
        },
    ];
    if (dossier.closed_at) {
        items.push({
            label: 'Afwikkeldatum',
            value: readableDate(dossier.closed_at),
        }, {
            label: 'Afwikkelreden',
            value: dossier.closing_description,
        });
    }
    if (dossier.objection_status) {
        items.push({
            label: 'Bezwaarstatus',
            value: t('objection_status.' + dossier.objection_status),
        });
    }
    return (_jsx(_Fragment, { children: items.map(item => {
            return (_jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: item.label }), _jsx(DataDefinition, { children: item.value })] }, item.label));
        }) }));
};
export default InvonedDossierDetails;
